import { ReactNode } from 'react';
import { AppLayout } from '../components/AppLayout';

const FaqLayout = ({ children }: { children: ReactNode }) => {
  return <AppLayout enableSiteTheme={false}>{children}</AppLayout>;
};

export default [FaqLayout];
